"use client";

import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";

import PitchCorrection from "@/components/pitchCorrection/PitchCorrection";

export function AutotuneModal({
  open,
  pitchGetter,
  originalPitchGetter,
  keyNamespace,
  sessionSlugGetter,
  userIsPaid,
  closeModal,
  disableDiatonicTranspose,
  namespace,
  signedUrlAudio,
  audioUrl,
  signedUrlModel,
  pitchesCb,
  track,
}: {
  open: boolean;
  pitchGetter: Promise<number[]>;
  originalPitchGetter: Promise<number[]>;
  sessionSlugGetter: Promise<string>;
  keyNamespace: string;
  userIsPaid: boolean;
  closeModal: () => void;
  disableDiatonicTranspose: boolean;
  namespace: string;
  signedUrlAudio: string | null;
  audioUrl: string;
  signedUrlModel: string | null;
  pitchesCb: (p: number[]) => void;
  track: number;
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:p-6`}
              >
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    tabIndex={-1}
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={closeModal}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <PitchCorrection
                  disableDiatonicTranspose={disableDiatonicTranspose}
                  namespace={namespace}
                  keyNamespace={keyNamespace}
                  signedUrlAudio={signedUrlAudio}
                  pitchGetter={pitchGetter}
                  originalPitchGetter={originalPitchGetter}
                  sessionSlugGetter={sessionSlugGetter}
                  actionName={"Done"}
                  track={track}
                  audioUrl={audioUrl}
                  signedUrlModel={signedUrlModel}
                  userIsPaid={userIsPaid}
                  callbackPitchesToModal={(p: number[]) => {
                    pitchesCb(p);
                    closeModal();
                  }}
                  // closeModalFromModal={() => { closeModal(); }}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
